import { useContext } from 'react';
import {
  AgxIdentityVerificationExports,
  cleanFullAddress,
  SAVE_BUTTON_STATES,
} from '@urbanx/agx.ui-components2';
import { AuthContext } from '@urbanx/agx.auth.client';
import { MenuTitles, Pages } from 'constants/menu';
import { useSelectedAgency, useSelectedCampaign } from 'hooks';
import { ContentLayout, PageLayout } from 'layout';
import PropertyInformationSubPage from '../PropertyInformationSubPage';

const VendorIdentityVerification = () => {
  const { userAccount } = useContext(AuthContext);
  const { agency } = useSelectedAgency();
  const { campaign } = useSelectedCampaign();

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.PROPERTY_INFORMATION}
        isCampaigns={true}
      >
        <PropertyInformationSubPage
          currentPage={Pages.PROPERTY_INFORMATION_IDENTITY_VERIFICATION}
          isLoading={!campaign?.campaignId}
          saveState={SAVE_BUTTON_STATES.UNSAVED}
          hasUnsavedChanges={false}
          onSave={() => undefined}
          saveButtonId="identityVerificationSaveChanges"
          saveButtonTestId="btn-identityVerificationSaveChanges"
          showChildren={!!campaign?.campaignId}
          hideSaveButton
        >
          <AgxIdentityVerificationExports
            id="VendorIdentityVerificationExports"
            campaignId={campaign?.campaignId ?? ''}
            mode="vendors"
          />
        </PropertyInformationSubPage>
      </ContentLayout>
    </PageLayout>
  );
};

export default VendorIdentityVerification;
